import React from "react";
import ConfigItem from "../config-items/ConfigItem";
import TemplateBig from "../templates/TemplateBig";
import ErrorBoundary from "../common/ErrorBoundary";
import {ITemplateConfig} from "../../../constants/interfaces";

type Props = {
    isActive: boolean,
    templateConfig: ITemplateConfig,
    updateConfig: Function,
    isEdit?: boolean
}


const ConfigTab = (props: Props) => (
    <div className={`config-tab ${props.isActive ? "d-block" : "d-none"}`}>
        <ErrorBoundary>
			{
				props.templateConfig.grid_type_id ? (
					<TemplateBig activeTemplate={props.templateConfig.grid_type_id}/>
				) : null
			}

        </ErrorBoundary>

        <div className="configuration mt-5">
            <h2 className="mb-4">Configuration</h2>

            <div className="config-list">
                <ErrorBoundary>
                    {
                        props.templateConfig.grid_config ? props.templateConfig.grid_config.map((item, index) => (
                           <ConfigItem 
                               key={index}
                               id={index}
                               templateId={props.templateConfig.grid_type_id}
                               item={item}
                               updateConfig={props.updateConfig}
							   isEdit={props.isEdit}
                               dashboardId={props.templateConfig.id}
                           />
                        )) : null
                    }
                </ErrorBoundary>
            </div>
        </div>
    </div>
);

export default ConfigTab;
